module.exports = __webpack_public_path__ + "5e1204f7c08a19b0af97c96be10ba898.png";